import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { updateGame } from "./ggame";
import { updateUserBalance } from "./userbal";

const initialState = {
  data: null,
  loading: false,
  error: null,
};
const authCraditSlice = createSlice({
  name: "cradit",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

export const {     } =
  authCraditSlice.actions;

export const CraditSlice = (data) => async (dispatch) => {
  try {
    // dispatch(loadingStart());
    // dispatch(requestStart());
    const response = await axios.post(`/private/user/cradit`, data);
    if (response.status === 200) {
      const { game, balance } = response.data;
      Object.assign(data, { query: "256" });
      dispatch(updateGame(game));
      dispatch(updateUserBalance(balance));
      toast.success(`${data?.name} balance is updated!`);
      // dispatch(loadingSuccess());
    } else if (response.status === 201) {
      Object.assign(data, { query: "256" });
      toast.success(`${data?.name} balance update in progress!`);
      // dispatch(loadingSuccess());
    }
    return true;
  } catch (err) {
    toast.error(
      err?.response?.data?.error || err?.response?.data?.message || err.message
    );
    // dispatch(closeModal());
    // dispatch(loadingFailure("here is end"));
    // dispatch(
    //   requestFailure(
    //     err?.response?.data?.error ||
    //       err?.response?.data?.message ||
    //       err.message ||
    //       "Something went wrong!"
    //   )
    // );
    return false;
  }
};

export default authCraditSlice.reducer;
